import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import t from "./has.js";
import e from "./ObjectPool.js";
var s = 4294967296,
    i = t("esri-text-decoder") ? new TextDecoder("utf-8") : null,
    r = t("safari") || t("ios") ? 6 : t("ff") ? 12 : 32;

var a = /*#__PURE__*/function () {
  function a(t, e) {
    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : t ? t.byteLength : 0;

    _classCallCheck(this, a);

    this._tag = 0, this._dataType = 99, this.init(t, e, s, i);
  }

  _createClass(a, [{
    key: "init",
    value: function init(t, e, s, i) {
      this._data = t, this._dataView = e, this._pos = s, this._end = i;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new a(this._data, this._dataView, this._pos, this._end);
    }
  }, {
    key: "pos",
    value: function pos() {
      return this._pos;
    }
  }, {
    key: "move",
    value: function move(t) {
      this._pos = t;
    }
  }, {
    key: "nextTag",
    value: function nextTag(t) {
      for (;;) {
        if (this._pos === this._end) return !1;

        var _e = this._decodeVarint();

        if (this._tag = _e >> 3, this._dataType = 7 & _e, !t || t === this._tag) break;
        this.skip();
      }

      return !0;
    }
  }, {
    key: "next",
    value: function next() {
      if (this._pos === this._end) return !1;

      var t = this._decodeVarint();

      return this._tag = t >> 3, this._dataType = 7 & t, !0;
    }
  }, {
    key: "empty",
    value: function empty() {
      return this._pos >= this._end;
    }
  }, {
    key: "tag",
    value: function tag() {
      return this._tag;
    }
  }, {
    key: "getInt32",
    value: function getInt32() {
      return this._decodeVarint();
    }
  }, {
    key: "getInt64",
    value: function getInt64() {
      return this._decodeVarint();
    }
  }, {
    key: "getUInt32",
    value: function getUInt32() {
      var t = 4294967295;
      return t = (127 & this._data[this._pos]) >>> 0, this._data[this._pos++] < 128 ? t : (t = (t | (127 & this._data[this._pos]) << 7) >>> 0, this._data[this._pos++] < 128 ? t : (t = (t | (127 & this._data[this._pos]) << 14) >>> 0, this._data[this._pos++] < 128 ? t : (t = (t | (127 & this._data[this._pos]) << 21) >>> 0, this._data[this._pos++] < 128 ? t : (t = (t | (15 & this._data[this._pos]) << 28) >>> 0, this._data[this._pos++] < 128 ? t : void 0))));
    }
  }, {
    key: "getUInt64",
    value: function getUInt64() {
      return this._decodeVarint();
    }
  }, {
    key: "getSInt32",
    value: function getSInt32() {
      var t = this.getUInt32();
      return t >>> 1 ^ -(1 & t) | 0;
    }
  }, {
    key: "getSInt64",
    value: function getSInt64() {
      return this._decodeSVarint();
    }
  }, {
    key: "getBool",
    value: function getBool() {
      var t = 0 !== this._data[this._pos];
      return this._skip(1), t;
    }
  }, {
    key: "getEnum",
    value: function getEnum() {
      return this._decodeVarint();
    }
  }, {
    key: "getFixed64",
    value: function getFixed64() {
      var t = this._dataView,
          e = this._pos,
          i = t.getUint32(e, !0) + t.getUint32(e + 4, !0) * s;
      return this._skip(8), i;
    }
  }, {
    key: "getSFixed64",
    value: function getSFixed64() {
      var t = this._dataView,
          e = this._pos,
          i = t.getUint32(e, !0) + t.getInt32(e + 4, !0) * s;
      return this._skip(8), i;
    }
  }, {
    key: "getDouble",
    value: function getDouble() {
      var t = this._dataView.getFloat64(this._pos, !0);

      return this._skip(8), t;
    }
  }, {
    key: "getFixed32",
    value: function getFixed32() {
      var t = this._dataView.getUint32(this._pos, !0);

      return this._skip(4), t;
    }
  }, {
    key: "getSFixed32",
    value: function getSFixed32() {
      var t = this._dataView.getInt32(this._pos, !0);

      return this._skip(4), t;
    }
  }, {
    key: "getFloat",
    value: function getFloat() {
      var t = this._dataView.getFloat32(this._pos, !0);

      return this._skip(4), t;
    }
  }, {
    key: "getString",
    value: function getString() {
      var t = this._getLength(),
          e = this._pos,
          s = this._toString(this._data, e, e + t);

      return this._skip(t), s;
    }
  }, {
    key: "getBytes",
    value: function getBytes() {
      var t = this._getLength(),
          e = this._pos,
          s = this._toBytes(this._data, e, e + t);

      return this._skip(t), s;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this._getLengthUnsafe();
    }
  }, {
    key: "processMessageWithArgs",
    value: function processMessageWithArgs(t, e, s, i) {
      var r = this.getMessage(),
          _a = t(r, e, s, i);

      return r.release(), _a;
    }
  }, {
    key: "processMessage",
    value: function processMessage(t) {
      var e = this.getMessage(),
          s = t(e);
      return e.release(), s;
    }
  }, {
    key: "getMessage",
    value: function getMessage() {
      var t = this._getLength(),
          e = a.pool.acquire();

      return e.init(this._data, this._dataView, this._pos, this._pos + t), this._skip(t), e;
    }
  }, {
    key: "release",
    value: function release() {
      a.pool.release(this);
    }
  }, {
    key: "dataType",
    value: function dataType() {
      return this._dataType;
    }
  }, {
    key: "skip",
    value: function skip() {
      switch (this._dataType) {
        case 0:
          this._decodeVarint();

          break;

        case 1:
          this._skip(8);

          break;

        case 2:
          this._skip(this._getLength());

          break;

        case 5:
          this._skip(4);

          break;

        default:
          throw new Error("Invalid data type!");
      }
    }
  }, {
    key: "skipLen",
    value: function skipLen(t) {
      this._skip(t);
    }
  }, {
    key: "_skip",
    value: function _skip(t) {
      if (this._pos + t > this._end) throw new Error("Attempt to skip past the end of buffer!");
      this._pos += t;
    }
  }, {
    key: "_decodeVarint",
    value: function _decodeVarint() {
      var t = this._data;
      var e,
          s = this._pos,
          i = 0;
      if (this._end - s >= 10) do {
        if (e = t[s++], i |= 127 & e, 0 == (128 & e)) break;
        if (e = t[s++], i |= (127 & e) << 7, 0 == (128 & e)) break;
        if (e = t[s++], i |= (127 & e) << 14, 0 == (128 & e)) break;
        if (e = t[s++], i |= (127 & e) << 21, 0 == (128 & e)) break;
        if (e = t[s++], i += 268435456 * (127 & e), 0 == (128 & e)) break;
        if (e = t[s++], i += 34359738368 * (127 & e), 0 == (128 & e)) break;
        if (e = t[s++], i += 4398046511104 * (127 & e), 0 == (128 & e)) break;
        if (e = t[s++], i += 562949953421312 * (127 & e), 0 == (128 & e)) break;
        if (e = t[s++], i += 72057594037927940 * (127 & e), 0 == (128 & e)) break;
        if (e = t[s++], i += 0x8000000000000000 * (127 & e), 0 == (128 & e)) break;
        throw new Error("Varint too long!");
      } while (0);else {
        var _r = 1;

        for (; s !== this._end && (e = t[s], 0 != (128 & e));) {
          ++s, i += (127 & e) * _r, _r *= 128;
        }

        if (s === this._end) throw new Error("Varint overrun!");
        ++s, i += e * _r;
      }
      return this._pos = s, i;
    }
  }, {
    key: "_decodeSVarint",
    value: function _decodeSVarint() {
      var t = this._decodeVarint();

      return t % 2 ? -(t + 1) / 2 : t / 2;
    }
  }, {
    key: "_getLength",
    value: function _getLength() {
      if (2 !== this._dataType) throw new Error("Not a delimited data type!");
      return this._decodeVarint();
    }
  }, {
    key: "_getLengthUnsafe",
    value: function _getLengthUnsafe() {
      return this.getUInt32();
    }
  }, {
    key: "_toString",
    value: function _toString(t, e, s) {
      if ((s = Math.min(this._end, s)) - e > r && i) {
        var _r2 = t.subarray(e, s);

        return i.decode(_r2);
      }

      var _a2 = "",
          n = "";

      for (var _i = e; _i < s; ++_i) {
        var _e2 = t[_i];
        128 & _e2 ? n += "%" + _e2.toString(16) : (_a2 += decodeURIComponent(n) + String.fromCharCode(_e2), n = "");
      }

      return n.length && (_a2 += decodeURIComponent(n)), _a2;
    }
  }, {
    key: "_toBytes",
    value: function _toBytes(t, e, s) {
      return s = Math.min(this._end, s), new Uint8Array(t.buffer, e, s - e);
    }
  }]);

  return a;
}();

a.pool = new e(a, null, function (t) {
  t._data = null, t._dataView = null;
});
export { a as default };